import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { ThinCard, CustomThinCard } from './ThinCard';
import { WideCard, CustomWideCard } from './WideCard';

interface CustomCardProps {
  customStyles?: string;
  wide?: boolean;
  thin?: boolean;
}

interface CardProps extends CustomCardProps {
  title: string;
  description?: string;
  imgSrc: string;
  imgAlt: string;
  buttonText: string;
  onClick: () => void;
  special?: boolean;
}

const Card: React.FC<CardProps> = ({ wide = false, thin = false, ...rest }) => {
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'));

  if (wide) return <WideCard {...rest} />;
  if (thin) return <ThinCard {...rest} />;

  return isWideScreen ? <WideCard {...rest} /> : <ThinCard {...rest} />;
};

export const CustomCard: React.FC<CustomCardProps> = ({ wide = false, thin = false, ...rest }) => {
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'));

  if (wide) return <CustomWideCard {...rest} />;
  if (thin) return <CustomThinCard {...rest} />;

  return isWideScreen ? <CustomWideCard {...rest} /> : <CustomThinCard {...rest} />;
};

export default Card;
